import React from "react";

import { faLightbulb } from "@fortawesome/pro-solid-svg-icons/faLightbulb";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Divider from "antd/es/divider";
import Tooltip from "antd/es/tooltip";
import { FormattedMessage } from "react-intl";

import styles from "./AdjustedAmountTooltip.module.scss";

interface Props {
  children: React.ReactNode;
}

const AdjustedAmountTooltip: React.FC<Props> = ({ children }) => (
  <Tooltip
    placement="bottom"
    title={
      <div>
        <div className={styles.tooltipTitle}>
          <FontAwesomeIcon icon={faLightbulb} />
          <span>
            <FormattedMessage
              id="deals.adjustedAmount.tooltip.title"
              defaultMessage="What is adjusted amount?"
              description="Forecast deal view. Column tooltip title"
            />
          </span>
        </div>
        <Divider className={styles.tooltipDivider} />
        <div className={styles.tooltipText}>
          <FormattedMessage
            id="deals.adjustedAmount.tooltip.text"
            defaultMessage="It’s calculated by multiplying the total amount of revenue in each deal stage by the probability of that stage"
            description="Forecast deal view. Column tooltip text"
          />
        </div>
      </div>
    }
  >
    {children}
  </Tooltip>
);

export default AdjustedAmountTooltip;
